import { type VragenSbiCodesSbiBeschrijvingDto } from '@services/vragen-public/api';
import { sbiCodesApi } from '@services/vragen-public/service';
import { logger } from '@logging/logging';

export async function sbiCodeLookupDetailsFn(
  sbiCode: string,
): Promise<VragenSbiCodesSbiBeschrijvingDto | undefined> {
  try {
    const res = await sbiCodesApi.sbiCodesSbiBeschrijving(sbiCode);
    return res.data.result ?? undefined;
  } catch (error: any) {
    if (error.status === 404) return;
    logger.error('Something went wrong while getting SBI details: ', error);
  }
}
